import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// menu apis
export const fetchMenus = async () => {
  // const res = await api.get(
  //   "/header-menus?populate=children&filters[parent][$null]=true&sort=order"
  // );

  const res = await api.get("/header-menus", {
    params: {
      populate: {
        page: true,
        children: {
          sort: ["order:asc"],
          populate: {
            page: true,
            children: {
              populate: {
                page: true,
              },
              sort: ["order:asc"],
            },
          },
        },
      },
      filters: {
        parent: {
          $null: true,
        },
      },
      sort: ["order:asc"],
    },
  });


  return res.data.data;
};

const globalPopulate = {
  logo: true,
  favicon: true,
  header: {
    populate: {
      Button: {
        populate: {
          icon: true,
        },
      },
    }
  },
  footer: {
    populate: {
      menus: {
        populate: {
          quick_links: {
            populate: "*"
          },
        }
      },
      servicesMenu: {
        populate: {
          service_menus: {
            populate: "*"
          },
        }
      },
    },
  },
  socialLinks: {
    populate: {
      icon: true,
    },
  },
  companyInfo: true,
};
// global settings api
export const fetchGlobalSettings = async () => {
  const res = await api.get("/global-setting", {
    params: {
      populate: globalPopulate,
    },
  });
  return res.data.data;
}

export const fetchHomePage = async () => {
  const res = await api.get("/pages", {
    params: {
      filters: {
        Title: {
          $eq: "Home",
        },
      },
      populate: {
        sections: {
          on: {
            "hero-section.hero-section": {
              populate: {
                heroImage: true,
              },
            },
            // imageWithText
            "sections.image-with-text": {
              populate: {
                image: true,
                Settings: true,
              },
            },
          },
        },
      },
    },
  });

  return res.data.data[0];
};

export const getLatestBlogs = async () => {
  const res = await api.get("/blogs", {
    params: {
      populate: {
        image: true,
        category: true,
      },
      sort: ["createdAt:desc"], // latest first
      pagination: {
        page: 1,
        pageSize: 3, // 👈 only 3 blogs
      },
    },
  });

  return res.data.data || [];
};

// blog apis
export const getBlogs = async (page = 1, pageSize = 6) => {
  const res = await api.get("/blogs", {
    params: {
      populate: {
        image: true,
        category: true,
      },
      pagination: {
        page,
        pageSize,
      },
    },
  });
  return {
    blogs: res.data.data || [],
    pagination: res.data.meta.pagination,
  };
};

export const getBlogBySlug = async (slug) => {
  const res = await api.get(
    `/blogs?filters[slug][$eq]=${slug}&populate=*`
  );
  return res.data.data?.[0] || null;
};

export const submitForm = async (formData) => {
  return await api.post("/form-submissions?sort[0]=id:DESC", {
    data: formData,
  });
};

export const getContactPage = async () => {
  const res = await api.get("/pages", {
    params: {
      filters: {
        Title: {
          $eq: "Contact",
        },
      },
      populate: {
        sections: {
          populate: "*",
        },
      },
    },
  });
  return res.data.data[0];
};

export const fetchPageBySlug = async (slug) => {
  const res = await api.get("/pages", {
    params: {
      filters: {
        slug: { $eq: slug },
      },
      populate: {
        sections: {
          on: {

            //teamMembers
            "sections.team-member": {
              populate: {
                image: true,
                secButton: {
                  populate: {
                    icon: true,
                  },
                },
              },
            },

            // coreCommitments
            "sections.core-commitments": {
              populate: {
                image: true,
                Settings: true,
                commitments: {
                  populate: {
                    image: true,
                  },
                },
              },
            },


            // aboutAreaSection
            "sections.about-area-section": {
              populate: {
                image: true,
                Settings: true,
                secButton: {
                  populate: {
                    icon: true,
                  },
                },
              },
            },

            // servicesSection
            "sections.services-card": {
              populate: {
                Settings: true,
                serviceCard: {
                  populate: {
                    image: true,
                    header_menu: {
                      populate: {
                        page: true,
                        parent: {
                          populate: {
                            children: true,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },

            // solutionCardSection
            "sections.solution-section": {
              populate: {
                Settings: true,
                solutionCard: {
                  populate: {
                    image: true,
                    header_menu: {
                      populate: {
                        page: true,
                        parent: {
                          populate: {
                            children: true,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },

            // testimonialsSection
            "sections.testimonial-section": {
              populate: {
                testimonial: {
                  populate: {
                    image: true,
                  },
                },
              },
            },
            //ctaSection
            "sections.cta-section": {
              populate: {
                Settings: true,
                image: true,
              },
            },

            //blogSection
            "sections.blog-section": {
              populate: {
                blogs: {
                  populate: {
                    image: true,
                    category: true,
                  },
                },
              },
            },

            //strategySection
            "sections.strategy-section": {
              populate: {
                Settings: true,
                strategyContents: {
                  populate: {
                    image: true,
                    Settings: true,
                  },
                },
              },
            },

            // missionList
            "sections.mission-list": {
              populate: {
                Settings: true,
                image: true,
              },
            },

            // industriesSection
            "sections.industries-section": {
              populate: {
                Settings: true,
                industriesCard: {
                  populate: {
                    image: true,
                    header_menu: {
                      populate: {
                        page: true,
                        parent: {
                          populate: {
                            children: true,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },

            "sections.stats-section": {
              populate: {
                statsItem: {
                  populate: {
                    image: true,
                  },
                },
              },
            },

            // imageWithText
            "sections.image-with-text": {
              populate: {
                Settings: true,
                image: true,
              },
            },

            // topFormWithText
            "sections.top-form-with-text": {
              populate: {
                image: true,
                Settings: true,
                secButton: {
                  populate: {
                    icon: true,
                  },
                },
              },
            },

            // richText
            "sections.content-editor": {
              populate: "*",
            },

            //faq
            "sections.faq": {
              populate: {
                faqs: true,
                Settings: true,
              },
            },

          },
        },
        seo: true,
      },
    },
  });

  const page = res.data.data[0];
  return page || null;
};


